"use client";

import React from "react";
import BFLLink from "@repo/shared-ui/BFLLink";
import { SocialMediaItem } from "../../interfaces/IHeader.interface";
import BFLImage from "@repo/shared-ui/BFLImage";
import { handleSocialMediaIconClickDL } from "../MobileHeader/MobileNavigationAnalyticsFunction";

interface FollowUsListProps {
  followUsList: SocialMediaItem[];
}

const FollowUsList: React.FC<FollowUsListProps> = ({ followUsList }) => {
  if (!followUsList || followUsList.length === 0) {
    return null;
  }

  return (
    <div className="justify-between px-6 pt-4 pb-2 text-center text-sm text-gray-900 hidden md:flex">
      <span className="flex items-center">Follow Us</span>
      <div className="mt-2 flex justify-center gap-5 md:mt-0 md:justify-end">
        {followUsList.map((item: SocialMediaItem) => (
          <BFLLink
            key={item.nodeName}
            href={item.followUsUrl}
            openInNewTab={item.followUsOpenInNewTab === "true" ? "_blank" : "_self"}
            onClick={() => handleSocialMediaIconClickDL(item.followUsTitle)}
          >
            <BFLImage
              src={item.followUsImagePath}
              alt={item.followUsImageAltText || item.followUsTitle}
              unoptimized={true}
              width={32}
              height={32}
            />
          </BFLLink>
        ))}
      </div>
    </div>
  );
};

export default FollowUsList;
